/*
 * Advance Greenshop - staffeltabel meelaten lopen met de variantkiezer
 *
 * Purchase Rules zet alle staffels van alle varianten al in de pagina, als
 * JSON op het data-tiers attribuut van .tier-pricing. Bij het laden bouwt hun
 * script daaruit de tabel voor de variant in data-variant-id. Wisselt de klant
 * daarna van variant, dan draait dat script niet opnieuw: de tabel blijft op
 * de vorige variant staan. De aangerekende prijzen kloppen wel, want die
 * worden aan de kassa berekend.
 *
 * Twee soorten staffels:
 *   - percentage: "vanaf 6: 5% korting"
 *   - fixed: een vaste stukprijs vanaf een aantal, "vanaf 6: € 54,20"
 *
 * Bij vaste staffels op producten met formaatvarianten staan soms dezelfde
 * bedragen op alle formaten, ook waar de stukprijs lager is dan de staffel
 * (0/4 gruis € 33,58 met "staffel" € 54,20). De kassa rekent zo'n staffel
 * niet aan, dus tonen we ze ook niet: rijen met een staffelprijs die niet
 * onder de stukprijs van het gekozen formaat ligt, vallen weg. Blijft er
 * niets over, dan verdwijnt het blok voor dat formaat.
 *
 * Heeft de standaardvariant geen staffel (tuingrond: los gestort zonder,
 * big bag met), dan maakt de app het blok leeg en zet er hidden op. Dan is er
 * geen tabel om rijen in te zetten, dus bouwen we het blok zelf volledig op:
 * kop, tabelkop en rijen, met dezelfde klassen en labels als de app.
 *
 * Geen netwerkaanvraag nodig, alles staat al in de pagina. Alles faalt stil:
 * herkent het script de opbouw niet, dan ziet de klant nooit een fout.
 */
(function () {
  'use strict';

  function maakCel(tag, tekst, klasse) {
    var cel = document.createElement(tag);
    cel.textContent = tekst;
    if (klasse) cel.className = klasse;
    return cel;
  }

  function verberg(el) {
    el.hidden = true;
    el.style.display = 'none';
  }

  function toon(el) {
    el.hidden = false;
    el.style.display = '';
  }

  /* Stukprijs van een variant in euro, uit de productgegevens die Shopify
     zelf op elke productpagina zet. Onbekend -> null (dan filteren we niet). */
  function variantPrijs(variantId, detail) {
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      var varianten = meta && meta.product && meta.product.variants;
      if (varianten) {
        for (var i = 0; i < varianten.length; i++) {
          if (String(varianten[i].id) === String(variantId)) return Number(varianten[i].price) / 100;
        }
      }
      /* Terugval: het variant-object van het event, prijs in centen zoals overal in Shopify. */
      if (detail && detail.resource && isFinite(Number(detail.resource.price))) {
        return Number(detail.resource.price) / 100;
      }
    } catch (e) {
      /* stil */
    }
    return null;
  }

  function geld(bedrag, valuta) {
    try {
      return new Intl.NumberFormat('nl-BE', { style: 'currency', currency: valuta || 'EUR' }).format(bedrag);
    } catch (e) {
      return '€ ' + bedrag.toFixed(2).replace('.', ',');
    }
  }

  function vulTabel(el, variantId, detail) {
    var data;
    try {
      data = JSON.parse(el.getAttribute('data-tiers') || '{}');
    } catch (e) {
      return;
    }

    var info = data[String(variantId)];

    /* Geen staffel voor deze variant: blok weg, anders tonen we iets fouts. */
    if (!info || !info.tiers || !info.tiers.length) {
      verberg(el);
      el.setAttribute('data-variant-id', String(variantId));
      return;
    }

    var vast = info.type === 'fixed';
    if (!vast && info.type !== 'percentage') return;

    var vanaf = el.getAttribute('data-i18n-from') || '{min}+';
    var korting = el.getAttribute('data-i18n-off') || '{value}% off';
    var valuta = el.getAttribute('data-currency') || 'EUR';
    var stukprijs = vast ? variantPrijs(variantId, detail) : null;

    var tiers = info.tiers.slice().sort(function (a, b) {
      return Number(a.min) - Number(b.min);
    });

    var tbody = document.createElement('tbody');
    for (var i = 0; i < tiers.length; i++) {
      var min = Number(tiers[i].min);
      var val = Number(tiers[i].value);
      if (!isFinite(min) || !isFinite(val)) continue;
      /* Vaste staffel die niet onder de stukprijs ligt: geen echte korting, weglaten. */
      if (vast && stukprijs !== null && val >= stukprijs) continue;
      var rij = document.createElement('tr');
      rij.appendChild(maakCel('td', vanaf.replace('{min}', min)));
      rij.appendChild(maakCel('td', vast ? geld(val, valuta) : korting.replace('{value}', val), 'tier-pricing__value'));
      tbody.appendChild(rij);
    }
    if (!tbody.children.length) {
      verberg(el);
      el.setAttribute('data-variant-id', String(variantId));
      return;
    }

    /* Bestaat de tabel van de app al, dan vervangen we enkel de rijen. */
    var bestaand = el.querySelector('table.tier-pricing__table tbody');
    if (bestaand) {
      bestaand.parentNode.replaceChild(tbody, bestaand);
    } else {
      el.innerHTML = '';
      if (el.getAttribute('data-show-heading') === '1' && el.getAttribute('data-heading')) {
        el.appendChild(maakCel('p', el.getAttribute('data-heading'), 'tier-pricing__heading'));
      }
      var tabel = document.createElement('table');
      tabel.className = 'tier-pricing__table';
      if (el.getAttribute('data-show-headers') === '1') {
        var thead = document.createElement('thead');
        var koprij = document.createElement('tr');
        koprij.appendChild(maakCel('th', el.getAttribute('data-i18n-qty') || 'Quantity'));
        koprij.appendChild(maakCel('th', el.getAttribute('data-i18n-price') || 'Price each'));
        thead.appendChild(koprij);
        tabel.appendChild(thead);
      }
      tabel.appendChild(tbody);
      el.appendChild(tabel);
    }

    el.setAttribute('data-variant-id', String(variantId));
    toon(el);
  }

  /* Ook bij het laden: de app bouwt de tabel voor de standaardvariant zonder
     de filter op de stukprijs, dus we bouwen ze meteen opnieuw. Na 'load' zijn
     alle uitgestelde scripts, ook dat van de app, al gedraaid. */
  function initieel() {
    try {
      document.querySelectorAll('.tier-pricing[data-tiers]').forEach(function (el) {
        var id = el.getAttribute('data-variant-id');
        if (id) vulTabel(el, id, null);
      });
    } catch (e) {
      /* stil falen */
    }
  }
  window.addEventListener('load', function () {
    initieel();
    setTimeout(initieel, 400);
  });

  document.addEventListener('variant:update', function (event) {
    try {
      var detail = event.detail || {};
      if (!detail.resource || !detail.resource.id) return;

      var sectie = event.target && event.target.closest && event.target.closest('.shopify-section');
      var bereik = sectie || document;

      bereik.querySelectorAll('.tier-pricing[data-tiers]').forEach(function (el) {
        vulTabel(el, detail.resource.id, detail);
      });
    } catch (e) {
      /* stil falen */
    }
  });
})();
